"use client"

import { useState, useEffect } from "react"
import { ChevronDown, MessageCircle, X } from "lucide-react"
import { Link } from 'react-router-dom'
import slide1 from '../images/slide1.jpg';
import slide2 from '../images/slide2.jpg';
import slide3 from '../images/slide3.jpg';
import slide4 from '../images/slide4.jpg';
import slide5 from '../images/slide5.jpg';
import slide6 from '../images/slide6.webp';

export default function FranchisePage() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isChatOpen, setIsChatOpen] = useState(false)
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false)
  const [currentSlide, setCurrentSlide] = useState(0)

  const constructionImages = [
    slide1,
    slide2,
    slide3,
    slide4,
    slide5,
    slide6
  ]
  
  const footerLinks = [
    { to: "/", label: "HOME" },
    { to: "/psdct", label: "PSDCT LIVE MODE" },
    { to: "/terms", label: "TERM & CONDITIONS" },
    { to: "/quick-payment", label: "QUICK PAY ANY FEES" },
    { to: "/registration-policy", label: "REGISTRATION POLICY" },
    { to: "/cancel", label: "CANCELLATION POLICY" },
    { to: "/careers", label: "CAREERS" },
    { to: "/contact", label: "CONTACT US" },
    { to: "/franchise", label: "FRANCHISE" },
    { to: "/free", label: "FREE" },
    { to: "/students", label: "STUDENTS" },
    { to: "/training", label: "TRAINING CENTERS" },
  ]

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % constructionImages.length)
    }, 4000)
    return () => clearInterval(slideInterval)
  }, [constructionImages.length])

  const handleChatSubmit = (e) => {
    e.preventDefault()
    console.log("Chat form submitted")
  }

  return (
    <div className="bg-white text-gray-800 min-h-screen overflow-x-hidden">
      {/* Header */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isScrolled
            ? "bg-white/20 backdrop-blur-2xl border-b border-white/10 shadow-xl"
            : "bg-gray-900/30 backdrop-blur-xl text-white border-b border-white/5"
        }`}
      >
        <div className="container mx-auto flex justify-between items-center p-4">
          <div
            className={`text-2xl font-bold transition-all duration-500 ${isScrolled ? "text-[#06b6d4]" : "text-white"}`}
          >
            <Link to="/" className="relative inline-block">
              <span className="bg-gradient-to-r from-[#00d4ff] via-[#5b21b6] to-[#ec4899] bg-clip-text text-transparent">
                StructuralGuru
              </span>
              <div className="absolute -inset-3 bg-gradient-to-r from-[#00d4ff]/20 via-[#5b21b6]/20 to-[#ec4899]/20 rounded-2xl blur-2xl opacity-50 animate-pulse"></div>
              <div
                className="absolute -inset-4 bg-gradient-to-r from-[#00d4ff]/15 via-[#5b21b6]/15 to-[#ec4899]/15 rounded-3xl blur-3xl opacity-30 animate-pulse"
                style={{ animationDelay: "1s" }}
              ></div>
            </Link>
          </div>
          <nav className="hidden md:flex space-x-6">
            <Link
              to="/"
              className={`relative font-medium transition-all duration-300 hover:scale-105 ${
                isScrolled ? "text-gray-700 hover:text-[#0f766e]" : "text-white hover:text-gray-200"
              } ${
                isScrolled
                  ? "hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:border hover:border-[#06b6d4]/50"
                  : "hover:shadow-[0_0_15px_rgba(255,255,255,0.4)] hover:border hover:border-white/50"
              } rounded-lg px-2 py-1 overflow-hidden after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-current after:transition-all after:duration-300 hover:after:w-full`}
            >
              HOME
            </Link>
            <Link
              to="/about"
              className={`relative font-medium transition-all duration-300 hover:scale-105 ${
                isScrolled ? "text-gray-700 hover:text-[#0f766e]" : "text-white hover:text-gray-200"
              } ${
                isScrolled
                  ? "hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:border hover:border-[#06b6d4]/50"
                  : "hover:shadow-[0_0_15px_rgba(255,255,255,0.4)] hover:border hover:border-white/50"
              } rounded-lg px-2 py-1 overflow-hidden after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-current after:transition-all after:duration-300 hover:after:w-full`}
            >
              ABOUT US
            </Link>
            <Link
              to="/services"
              className={`relative font-medium transition-all duration-300 hover:scale-105 ${
                isScrolled ? "text-gray-700 hover:text-[#0f766e]" : "text-white hover:text-gray-200"
              } ${
                isScrolled
                  ? "hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:border hover:border-[#06b6d4]/50"
                  : "hover:shadow-[0_0_15px_rgba(255,255,255,0.4)] hover:border hover:border-white/50"
              } rounded-lg px-2 py-1 overflow-hidden after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-current after:transition-all after:duration-300 hover:after:w-full`}
            >
              SERVICES
            </Link>
            <Link
              to="/projects"
              className={`relative font-medium transition-all duration-300 hover:scale-105 ${
                isScrolled ? "text-gray-700 hover:text-[#0f766e]" : "text-white hover:text-gray-200"
              } ${
                isScrolled
                  ? "hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:border hover:border-[#06b6d4]/50"
                  : "hover:shadow-[0_0_15px_rgba(255,255,255,0.4)] hover:border hover:border-white/50"
              } rounded-lg px-2 py-1 overflow-hidden after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-current after:transition-all after:duration-300 hover:after:w-full`}
            >
              OUR ENGG PROJECTS
            </Link>
            <div className="relative">
              <button
                onClick={() => setIsMoreDropdownOpen(!isMoreDropdownOpen)}
                className={`flex items-center space-x-1 font-medium transition-all duration-300 hover:scale-105 ${
                  isScrolled ? "text-gray-700 hover:text-[#0f766e]" : "text-white hover:text-gray-200"
                } ${
                  isScrolled
                    ? "hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:border hover:border-[#06b6d4]/50"
                    : "hover:shadow-[0_0_15px_rgba(255,255,255,0.4)] hover:border hover:border-white/50"
                } rounded-lg px-2 py-1`}
                aria-expanded={isMoreDropdownOpen}
                aria-haspopup="true"
              >
                <span>MORE</span>
                <ChevronDown
                  className={`w-4 h-4 transition-transform duration-300 ${isMoreDropdownOpen ? "rotate-180" : ""}`}
                />
              </button>
              <div
                className={`absolute top-full right-0 mt-2 w-48 bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-gray-200/20 overflow-hidden transition-all duration-300 ${
                  isMoreDropdownOpen ? "opacity-100 translate-y-0 visible" : "opacity-0 -translate-y-4 invisible"
                }`}
              >
                <Link
                  to="/privacy"
                  className="block px-6 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#0f766e] transition-all duration-200"
                  onClick={() => setIsMoreDropdownOpen(false)}
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/quality"
                  className="block px-6 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#0f766e] transition-all duration-200"
                  onClick={() => setIsMoreDropdownOpen(false)}
                >
                  Quality Policy
                </Link>
                
              </div>
            </div>
          </nav>
          {/* Mobile menu button */}
          <button className="md:hidden text-white">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-6 bg-gray-50 relative overflow-hidden pt-20">
        {/* Construction Images Slideshow Background */}
        <div className="absolute inset-0">
          {constructionImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? "opacity-20" : "opacity-0"
              }`}
            >
              <img
                src={image || "/placeholder.svg"}
                alt={`Construction Site ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
          {/* Overlay gradients */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#0f766e]/30 via-white/80 to-[#7c3aed]/20"></div>
        </div>

        {/* Animated background elements */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-r from-[#06b6d4]/20 to-[#8b5cf6]/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-gradient-to-l from-[#7c3aed]/20 to-[#06b6d4]/10 rounded-full blur-3xl animate-pulse"></div>
        </div>

        <div className="max-w-5xl mx-auto bg-white/60 backdrop-blur-xl p-8 my-16 rounded-3xl shadow-2xl border border-white/20 relative">
          <h1 className="text-3xl font-bold mb-6 text-center">
            <span className="bg-gradient-to-r from-[#0f766e] via-[#7c3aed] to-[#0f766e] bg-clip-text text-transparent">
              Franchise / Partnership Opportunity
            </span>
          </h1>
          <p className="text-lg text-center mb-6 text-gray-600 leading-relaxed">
            Collaborate with{" "}
            <strong className="bg-gradient-to-r from-[#0f766e] to-[#7c3aed] bg-clip-text text-transparent">
              StructuralGuru
            </strong>{" "}
            to become an authorized training center and bring quality structural engineering education to your region.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="group bg-white/40 backdrop-blur-sm p-6 rounded-2xl border border-white/30 hover:shadow-lg hover:scale-105 transition-all duration-300 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-[#06b6d4]/5 to-[#7c3aed]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10">
                <h2 className="text-xl font-semibold mb-4">
                  <span className="bg-gradient-to-r from-[#0f766e] to-[#7c3aed] bg-clip-text text-transparent">
                    Who Can Apply?
                  </span>
                </h2>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                    <span className="text-[#06b6d4] mt-1">•</span>
                    Engineering colleges and polytechnic institutions
                  </li>
                  <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                    <span className="text-[#06b6d4] mt-1">•</span>
                    Professional training institutes
                  </li>
                  <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                    <span className="text-[#06b6d4] mt-1">•</span>
                    Civil engineering consultants with training facilities
                  </li>
                  <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                    <span className="text-[#06b6d4] mt-1">•</span>
                    Educators looking to expand with industry-recognized content
                  </li>
                </ul>
              </div>
            </div>

            <div className="group bg-white/40 backdrop-blur-sm p-6 rounded-2xl border border-white/30 hover:shadow-lg hover:scale-105 transition-all duration-300 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-[#7c3aed]/5 to-[#06b6d4]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10">
                <h2 className="text-xl font-semibold mb-4">
                  <span className="bg-gradient-to-r from-[#7c3aed] to-[#0f766e] bg-clip-text text-transparent">
                    What You Get
                  </span>
                </h2>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                    <span className="text-[#7c3aed] mt-1">•</span>
                    Authorized training partner status & branding support
                  </li>
                  <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                    <span className="text-[#7c3aed] mt-1">•</span>
                    Curriculum, materials, software licenses, and trainer support
                  </li>
                  <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                    <span className="text-[#7c3aed] mt-1">•</span>
                    Marketing assistance and student referrals from our network
                  </li>
                  <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                    <span className="text-[#7c3aed] mt-1">•</span>
                    Revenue-sharing or royalty-based models available
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-10 bg-white/40 backdrop-blur-sm p-6 rounded-2xl border border-white/30 hover:shadow-lg transition-all duration-300">
            <h2 className="text-xl font-semibold mb-4">
              <span className="bg-gradient-to-r from-[#0f766e] via-[#06b6d4] to-[#7c3aed] bg-clip-text text-transparent">
                How to Partner With Us
              </span>
            </h2>
            <p className="mb-4 text-gray-700">
              Email us your interest at{" "}
              <a
                href="mailto:franchise@structuralguru.in"
                className="font-semibold bg-gradient-to-r from-[#0f766e] to-[#7c3aed] bg-clip-text text-transparent hover:from-[#06b6d4] hover:to-[#8b5cf6] transition-all duration-300 relative group"
              >
                structuralgurufranchisemanager@gmail.com
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#06b6d4] to-[#7c3aed] group-hover:w-full transition-all duration-300"></span>
              </a>{" "}
              with the following details:
            </p>
            <ul className="space-y-2 text-gray-700 mb-6">
              <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                <span className="text-[#06b6d4] mt-1">•</span>
                Institute/Organization name and address
              </li>
              <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                <span className="text-[#06b6d4] mt-1">•</span>
                Contact person details
              </li>
              <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                <span className="text-[#06b6d4] mt-1">•</span>
                Facility capacity and training infrastructure
              </li>
              <li className="flex items-start gap-3 p-2 hover:bg-white/50 rounded-xl transition-all duration-300">
                <span className="text-[#06b6d4] mt-1">•</span>
                Experience in training/consultancy (if any)
              </li>
            </ul>
            <p className="text-gray-700">
              We will get back to you within 3-5 working days after reviewing your profile.
            </p>
          </div>

          <div className="text-center mt-10">
            <Link
              to="/contact"
              className="inline-block bg-gradient-to-r from-[#0f766e] to-[#7c3aed] text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 hover:shadow-lg hover:scale-105 hover:-translate-y-0.5 hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] relative overflow-hidden group"
            >
              <span className="relative z-10">Contact Us for Franchise</span>
              <div className="absolute inset-0 bg-gradient-to-r from-[#06b6d4] to-[#8b5cf6] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white text-sm py-10 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-72 h-72 bg-gradient-to-r from-[#06b6d4]/10 to-[#8b5cf6]/5 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-gradient-to-l from-[#7c3aed]/10 to-[#06b6d4]/5 rounded-full blur-3xl animate-pulse"></div>
        </div>
        <div className="relative z-10">
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center gap-4 text-center mb-6">
              {footerLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.to}
                  className="px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-gradient-to-r hover:from-[#06b6d4] hover:to-[#7c3aed] transition-all duration-300 border border-gray-600 rounded-lg hover:border-[#06b6d4] hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] relative overflow-hidden group transform hover:scale-105 hover:-translate-y-1"
                >
                  <span className="relative z-10">{link.label}</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-[#06b6d4]/20 to-[#7c3aed]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#06b6d4] group-hover:w-full transition-all duration-300"></div>
                </Link>
              ))}
            </div>
            <div className="text-center border-t border-gray-600 pt-6">
              <p className="text-gray-400 mb-2">
                &copy; 2025 StructuralGuru - GURURAYAR ASSOCIATES. All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating Chat Widget */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={() => setIsChatOpen(!isChatOpen)}
          className="bg-gradient-to-r from-[#0f766e] to-[#7c3aed] text-white p-4 rounded-full shadow-2xl hover:shadow-[0_0_20px_rgba(6,182,212,0.6)] transition-all duration-300 hover:scale-110 hover:-translate-y-1 relative overflow-hidden group"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#06b6d4] to-[#8b5cf6] opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full"></div>
          <div className="relative z-10">
            {isChatOpen ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
          </div>
        </button>
      </div>

      {/* Chat Box */}
      <div
        className={`fixed bottom-24 right-6 w-80 bg-white/95 backdrop-blur-xl border border-gray-200/20 rounded-3xl shadow-2xl transition-all duration-500 z-40 ${
          isChatOpen ? "opacity-100 translate-y-0 visible" : "opacity-0 translate-y-8 invisible"
        }`}
      >
        <div className="p-6">
          <h3 className="text-xl font-semibold text-center mb-6">
            <span className="bg-gradient-to-r from-[#0f766e] to-[#7c3aed] bg-clip-text text-transparent">
              Customer Support
            </span>
          </h3>
          <form onSubmit={handleChatSubmit} className="space-y-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-3 bg-gray-50/50 border border-gray-200/50 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#0f766e]/20 focus:border-[#0f766e]/30 transition-all duration-300"
                required
              />
            </div>
            <div className="relative">
              <input
                type="email"
                placeholder="Your Email"
                className="w-full px-4 py-3 bg-gray-50/50 border border-gray-200/50 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#0f766e]/20 focus:border-[#0f766e]/30 transition-all duration-300"
                required
              />
            </div>
            <div className="relative">
              <textarea
                placeholder="How can I help you?"
                rows={3}
                className="w-full px-4 py-3 bg-gray-50/50 border border-gray-200/50 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#0f766e]/20 focus:border-[#0f766e]/30 transition-all duration-300 resize-none"
                required
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-[#0f766e] to-[#7c3aed] text-white py-3 rounded-2xl font-medium transition-all duration-300 hover:shadow-lg hover:scale-105 hover:-translate-y-0.5 hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] relative overflow-hidden group"
            >
              <span className="relative z-10">Customer Care for Support</span>
              <div className="absolute inset-0 bg-gradient-to-r from-[#06b6d4] to-[#8b5cf6] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
